import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ILoginResponse, IResponse } from '@interfaces/index';
import { AppRoutingService } from '@ui-components/services/app-routing.service';

import { AuthService } from '../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppService } from '@ui-components/services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  form: FormGroup;
  loading = false;

  constructor(
    protected _fb: FormBuilder,
    protected _app_service: AppService,
    protected _app_routing_service: AppRoutingService,
    protected _auth_service: AuthService,
    protected _cookie_service: CookieService,
    protected _router: Router
  ) {
    this.form = this._fb.group({
      email: [null, Validators.required]
    })
  }

  login() {
    if (this.form.valid) {
      this.loading = true;
      this._auth_service.forgotPassword(this.form.get('email')?.value).subscribe(
        (response: IResponse<ILoginResponse>) => {
          if(response.code === 200) {
            this.loading = false;
              this._router.navigate(['/reset-link-confirmation']);
          }
        },
        (response: HttpErrorResponse) => {
          this.loading = false;
          this._app_service.notify(response.error.message, 'error')
        }
      )
    }
  }
}
